export const escapeForRegExp = (query) => {
  return query.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
};
